/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-node',
    templateUrl: './chart-node.component.html',
    styleUrls: ['./chart-node.component.scss']
})
export class ChartNodeComponent {
    /**
     * Incoming data to populate node.
     */
    @Input() set data(data) {
        this._data = data;
    }

    /**
     * Data.
     * @private
     */
    private _data: any;

    get data() {
        return this._data;
    }
}
